<template>
	<b-tr>
		<b-td>
			<custom-select
				id="example-select"
				v-model="data.currency"
				plain
			>
				<b-form-select-option :value="data.currency">
					{{ data.currency }}
				</b-form-select-option>
			</custom-select>
		</b-td>
		<b-td>
			<b-form-input
				v-model="data.price"
				type="text"
				class="form-control-sm"
			/>
		</b-td>
		<b-td class="text-center">
			<custom-select
				id="example-select"
				v-model="data.scope"
				plain
			>
				<b-form-select-option :value="data.scope">
					{{ data.scope }}
				</b-form-select-option>
			</custom-select>
		</b-td>

		<b-td>
			<b-btn-group>
				<b-button
					size="sm"
					variant="alt-primary"
					@click="removeHandlingPrice()"
				>
					<i class="fa fa-fw fa-eraser" />
				</b-button>
			</b-btn-group>
		</b-td>
	</b-tr>
</template>
<script>
import CustomSelect from 'components/CustomSelect';

export default {
	components: {
		CustomSelect,
	},
	props: ['item'],
	emits: ['removeItem'],
	data() {
		return {
			data: {
				id: this.item.id,
				currency: this.item.currency,
				price: this.item.price,
				scope: this.item.scope,
			},
		};
	},
	methods: {
		removeHandlingPrice() {
			this.$emit(
				'removeItem',
				this.data.id,
			);
		},
	},
};
</script>
